import { Box } from '@mui/material';
import { FC } from 'react';
import { EditButton } from '../head/editButton';

type Props = {
  canEdit: boolean;
  changeMode: () => void;
};

export const DataViewEditBoxNoHead: FC<Props> = ({ canEdit, changeMode }) => {
  if (!canEdit) {
    return <></>;
  }

  return (
    <Box display={'flex'} justifyContent={'flex-end'} paddingBottom={1}>
      <EditButton onClick={changeMode} />
    </Box>
  );
};
